import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialCommitteeMeetingAttendanceState: Dtos.CommitteeMeetingAttendance & IRegistrationFormState = {
    id: null,
    committeeMeetingId: null,
    committeeMeeting: null,
    personnelId: null,
    personnel: null,
    committeeMeetingAttendanceStatusId: null,
    committeeMeetingAttendanceStatus: null,
    comment: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ICommitteeMeetingAttendanceReduxFormState {
    id: IFieldState<number>,
    committeeMeetingId: IFieldState<number>,
    personnelId: IFieldState<number>;
    committeeMeetingAttendanceStatusId: IFieldState<number>;
    comment: IFieldState<string>;
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
}
